<template>
    <ui-data-table 
        :p-headers="headers"
        p-title="Setores de impressão"
        p-read-link="print.read.one"
        p-create-link="print.create"
        p-name="imp-sector"
    />
</template>
<script>

import {uiDataTable} from '@/components/ui'
export default {
    name: 'vwPrintRead',
    components: {
        uiDataTable  
    },
    data(){
        return {
            headers: [{
                text: 'id',
                value: 'id'
            }, {
                text: 'descrição',
                value: 'descricao'
            }, {
                text: 'Cadastrado',
                value: 'criado_em'
            }, {
                text: 'Ações', 
                value: 'actions', 
                sortable: false
            }],
        }
    },
}
</script>